import styled from "styled-components";

export const TitleTab = styled.div`
padding: 0 60px;
background: #F5F5F5;
box-shadow: 0 2px 8px 0 rgba(0,0,0,0.30);
display: flex;
flex-direction: row;
align-items: center;
justify-content: flex-start;
height: 80px;
position: relative;
`;
